export const socialMessages = {
  comments: ['Комментарии', 'Comments', 'Şərhlər'],
  replyFor: ['Ответ для {{name}}', 'Reply to {{name}}', '{{name}} üçün cavab'],
  moreReplies: [
    'Ещё {{count}} ответов',
    '{{count}} more replies',
    'Daha {{count}} cavab',
  ],
  post: ['Пост', 'Post', 'Paylaşım'],
  story: ['История', 'Story', 'Hekayə'],
  reels: ['Reels', 'Reels', 'Reels'],
  isBold: ['Жирный', 'Bold', 'Qalın'],
  isItalic: ['Курсив', 'Italic', 'Kursiv'],
  isUnderline: ['Подчёркнутый', 'Underline', 'Altıxətli'],
  isStrikethrough: ['Зачёркнутый', 'Strikethrough', 'Üstündən xətt'],
  caption: ['Подпись', 'Caption', 'Mətn'],
  tagPeople: ['Отметить людей', 'Tag people', 'İnsanları etiketlə'],
  news: ['Новость', 'News', 'Xəbər'],
  camera: ['Камера', 'Camera', 'Kamera'],
  cameraPermission: [
    'Разрешите камеру и микрофон или выберите файл.',
    'Allow camera and microphone access or choose a file.',
    'Kamera və mikrofon girişinə icazə verin və ya fayl seçin.',
  ],
  capture: ['Снять фото', 'Take photo', 'Foto çək'],
  record: ['Записать видео', 'Record video', 'Video çək'],
  stop: ['Остановить', 'Stop', 'Dayandır'],
  postLimit: [
    'Для поста — до 10 файлов по 30 МБ; для истории — 1 файл до 100 МБ; Reels — 1 видео до 100 МБ и 60 секунд.',
    'Posts: up to 10 files, 30 MB each. Story: 1 file, 100 MB. Reels: 1 video, 100 MB, 60 seconds.',
    'Paylaşım: hər biri 30 MB olmaqla 10 fayl. Hekayə: 1 fayl, 100 MB. Reels: 1 video, 100 MB, 60 saniyə.',
  ],
  publicationPending: ['Публикуется…', 'Publishing…', 'Dərc edilir…'],
  publicationDone: ['Опубликовано', 'Published', 'Dərc edilib'],
  publicationFailed: [
    'Не удалось опубликовать',
    'Publication failed',
    'Dərc etmək alınmadı',
  ],
  blockAuthor: ['Заблокировать автора', 'Block author', 'Müəllifi blokla'],
  blockConfirm: [
    'Заблокировать автора и скрыть его публикации?',
    'Block this author and hide their posts?',
    'Müəllif bloklansın və paylaşımları gizlənsin?',
  ],
  likedBy: ['Кому понравилось', 'Liked by', 'Bəyənənlər'],
  following: ['Вы подписаны', 'Following', 'İzlənilir'],
  follow: ['Подписаться', 'Follow', 'İzlə'],
  unfollowConfirm: [
    'Отписаться от @{{name}}?',
    'Unfollow @{{name}}?',
    '@{{name}} izləməsi dayandırılsın?',
  ],
  people: ['Люди', 'People', 'İnsanlar'],
  posts: ['Публикации', 'Posts', 'Paylaşımlar'],
  recent: ['Недавние запросы', 'Recent searches', 'Son axtarışlar'],
  clear: ['Очистить', 'Clear', 'Təmizlə'],
  recommendations: ['Вам может понравиться', 'You may like', 'Bəyənə bilərsiniz'],
  today: ['Сегодня', 'Today', 'Bu gün'],
  yesterday: ['Вчера', 'Yesterday', 'Dünən'],
  earlier: ['Ранее', 'Earlier', 'Əvvəllər'],
  notifications: ['Уведомления', 'Notifications', 'Bildirişlər'],
  viewAs: ['Как меня видят', 'View as visitor', 'Ziyarətçi kimi bax'],
  previewProfile: [
    'Так выглядит ваш профиль',
    'This is how your profile looks',
    'Profiliniz belə görünür',
  ],
  profileQr: ['QR-код профиля', 'Profile QR code', 'Profilin QR kodu'],
  addText: ['Добавить текст', 'Add text', 'Mətn əlavə et'],
  fontSize: ['Размер шрифта', 'Font size', 'Şrift ölçüsü'],
  rotation: ['Поворот', 'Rotation', 'Dönmə'],
  scale: ['Масштаб', 'Scale', 'Miqyas'],
  fontWeight: ['Начертание', 'Weight', 'Qalınlıq'],
  textBackground: ['Подложка', 'Background', 'Fon'],
  none: ['Нет', 'None', 'Yoxdur'],
  fill: ['Заливка', 'Fill', 'Doldurma'],
  inverse: ['Инверсия', 'Inverse', 'İnversiya'],
  crop: ['Кадр', 'Crop', 'Kəsim'],
  filter: ['Фильтр', 'Filter', 'Filtr'],
  muteVideo: ['Без звука', 'Mute audio', 'Səssiz'],
  processing: [
    'Обработка… {{percent}}%',
    'Processing… {{percent}}%',
    'Emal edilir… {{percent}}%',
  ],
  unsupportedExport: [
    'Этот браузер не поддерживает обработку видео. Изменения не сохранены.',
    'This browser cannot process video. Changes were not saved.',
    'Bu brauzer videonu emal edə bilmir. Dəyişikliklər saxlanılmadı.',
  ],
} as const;
